<template>
    <div class="virtual-tour">
        <iframe
            :src="src"
            bordersize="0"
            allowfullscreen="true"
            allow="vr,gyroscope,accelerometer"
            class="virtual-tour embed-responsive-item"
        >
        </iframe>
    </div>
</template>

<script>
export default {
    props:{
        src:{
            type: String,
            required: true
        }
    },

    data(){ 
        return{
            real_src: null,
        }
        
    },

    mounted(){
        setTimeout(
            ()=>{
                this.real_src = this.src
            },
            500);
        
    }
}
</script>

<style>

</style>